import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom'
import logoImage from "./logo.jpg"



const HeaderLogo = (classes) => (
  <Button component={Link} to="/home"><img src={logoImage} className={classes.header} alt="logo"/></Button>
);

export default HeaderLogo;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderLogo.js